<template>
  <div class="container bg-white">
    <div class="row">
      <div class="col-md-6 border-1 border-gray">
        <index-graph></index-graph>
      </div>
      <div class="col-md-6 text-center">
        <pulse-loader
          v-if="loading"
          class="m-5"
        ></pulse-loader>
        <div class="row" v-else>
          <div class="col-md-4">
            <div class="card border-success mb-3" style="max-width: 18rem">
              <div class="card-header">Advanced</div>
              <div class="card-body text-success">
                <h5 class="card-title">{{ advance }}</h5>
                <p class="card-text"></p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card border-danger mb-3" style="max-width: 18rem">
              <div class="card-header">Declined</div>
              <div class="card-body text-danger">
                <h5 class="card-title">{{ decline }}</h5>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card border-primary mb-3" style="max-width: 18rem">
              <div class="card-header">Neutral</div>
              <div class="card-body text-primary">
                <h5 class="card-title">{{ neutral }}</h5>
              </div>
            </div>
          </div>
        </div>
        <pulse-loader
          v-if="loadingTVV"
          class=" m-2"
        ></pulse-loader>

        <div class="row" v-else>
          <table class="table table-striped fs-7">
            <thead>
              <tr>
                <th scope="col">Total Trade</th>
                <th scope="col">Total Volume</th>
                <th scope="col">Total Value(In MN)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ totalTrade }}</td>
                <td>{{ totalVolume }}</td>
                <td>{{ totalValue }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div class="col-md-4"></div> -->
    </div>
  </div>
</template>

<script>
import IndexGraph from "./IndexGraph.vue";
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    IndexGraph,
    PulseLoader
    
  },
  data() {
    return {
      advance: 0,
      decline: 0,
      neutral: 0,
      totalTrade: 0,
      totalValue: 0,
      totalVolume: 0,
      fetchedData: null,
      loading: 1,
      loadingTVV : 1,
      base_url:
        process.env.NODE_ENV === "production"
          ? "https://apidfl.bicm.ac.bd"
          : "http://localhost:8000",
    };
  },
  methods: {
    loadADNData() {
      Vue.axios
        .get(this.base_url + "/api/todays-advance-decline-neutral?timestamp=" + new Date().getTime())
        .then((response) => {
          this.fetchedData = response.data;
          this.advance = this.fetchedData["Advanced"];
          this.decline = this.fetchedData["Declined"];
          this.neutral = this.fetchedData["Neutral"];
          this.loading = 0;
        });
    },
    loadTVVData() {
      Vue.axios
        .get(this.base_url + "/api/todays-trade-value-volume?timestamp=" + new Date().getTime())
        .then((response) => {
          this.fetchedData = response.data;
          this.totalTrade = this.fetchedData["Total Trade"];
          this.totalValue = this.fetchedData["Total Value"];
          this.totalVolume = this.fetchedData["Total Volume"];
          this.loadingTVV = 0;
        });
    },
  },
  mounted() {
    this.loadADNData();
    this.loadTVVData();
  },
};
</script>

<style></style>
